























import Vue from 'vue'
import style from './style.module.scss'

import buttonRed from '@/components/common/click/button/button-red.vue'
import ButtonWhiteNoBorder from '@/components/common/click/button/button-white-no-border.vue'

export default Vue.extend({
    name: 'result',
    components: {
        buttonRed,
        ButtonWhiteNoBorder
    },
    props: {
        isUpdate: {
            type: Boolean,
            required: false,
            default: false
        },
        showRegisterInfo: {
            type: Boolean,
            required: false,
            default: false
        },
        subcontactsView: {
            type: Boolean,
            required: false,
            default: false
        },
        CommercialPropositionsEditedCount: {
            type: Number,
            required: false,
            default: 0
        },
        commercialPropositionsCount: {
            type: Number,
            required: false,
            default: 0
        },
        customersInvitedCount: {
            type: Number,
            required: false,
            default: 0
        },
        isSubcontractNewCreated: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            style: style,
            CommercialPropositionsEditedTitles: ['запрос', 'запроса', 'запросов'],
            commercialPropositionsNewTitles: ['новый запрос', 'новых запроса', 'новых запросов'],
            commercialPropositionsTitles: ['запрос', 'запроса', 'запросов'],
            customersInvitedTitles: ['продавцу', 'продавцам', 'продавцам'],
            createdTitles: ['Создан', 'Создано', 'Созданы']
        }
    },
    methods: {
        declOfNum(number: number, titles: string[]): string {
            const cases = [2, 0, 1, 1, 1, 2];
            return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
        },
    },
    computed: {
        sentenceEnding() {
            return this.isUpdate ? 'изменен' : 'создан';
        },
        commercialPropositionsEditedCountText(): string {
            return this.declOfNum(this.CommercialPropositionsEditedCount, this.CommercialPropositionsEditedTitles);
        },
        commercialPropositionsCountText(): string {
            return this.isSubcontractNewCreated ?
                this.declOfNum(this.commercialPropositionsCount, this.commercialPropositionsNewTitles) :
                this.declOfNum(this.commercialPropositionsCount, this.commercialPropositionsTitles);
        },
        customersInvitedCountText(): string {
            return this.declOfNum(this.customersInvitedCount, this.customersInvitedTitles);
        },
        createdCountText(): string{
            return this.declOfNum(this.commercialPropositionsCount, this.createdTitles);
        },
    }
})
